import { Stagger, StaggerItem } from "../common/Reveal";
import { stats } from "../../data/content";

export const StatsBand = () => (
    <section className="relative bg-navy-deep text-white border-b border-white/10" data-testid="stats-band">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-20">
            <Stagger className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-sm overflow-hidden">
                {stats.map((s) => (
                    <StaggerItem key={s.label} className="bg-navy-deep p-8 lg:p-10 hover:bg-navy transition-colors duration-300">
                        <s.icon size={34} weight="duotone" className="text-brand mb-6" />
                        <div className="font-display font-extrabold text-2xl lg:text-4xl tracking-tight leading-none">{s.value}</div>
                        <div className="mt-2 text-sm font-semibold text-white">{s.label}</div>
                        <div className="mt-1 text-xs text-slate-400">{s.sub}</div>
                    </StaggerItem>
                ))}
            </Stagger>
        </div>
    </section>
);
